<template>
  <div class="comment-status">
    <TransitionFadeInOut mode="out-in">
      <div v-if="draftIdUpdated === commentId" class="comment-status-saved">
        <span class="comment-status-save-text">{{ t('cc_badge_draft_saved') }}</span>
        <FriedIcon icon="bold-check-mark" class="comment-saved-icon" />
      </div>
      <div v-else-if="draftIdUpdating === commentId" class="comment-status-saving">
        <span class="comment-status-save-text">{{ t('cc_badge_autosaving_draft') }}</span>
        <FriedSpinner :size="20" />
      </div>
      <FriedStatusBadge v-else :text="t('cc_badge_draft')" />
    </TransitionFadeInOut>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { TransitionFadeInOut } from '@getaccept/fried-tofu';
import { useContextualCommentingStore } from '../../store/contextual-commenting.store';

export default defineComponent({
  components: {
    TransitionFadeInOut,
  },
  props: {
    commentId: {
      type: String,
      required: true,
    },
  },
  setup() {
    const { t } = useI18n();
    const store = useContextualCommentingStore();
    const { draftIdUpdating, draftIdUpdated } = storeToRefs(store);
    return { t, draftIdUpdating, draftIdUpdated };
  },
});
</script>
<style lang="scss" scoped>
.comment-status {
  align-self: flex-end;
  margin-top: var(--spacing-25);
  height: 30px;
  display: flex;
  align-items: center;

  .comment-status-saving,
  .comment-status-saved {
    display: flex;

    .comment-status-save-text {
      white-space: nowrap;
      margin-right: var(--spacing-50);
    }

    .comment-saved-icon {
      color: var(--success-dark);
    }
  }
}
</style>
